// @generated by protoc-gen-es v2.6.3 with parameter "keep_empty_files=true,target=js+dts"
// @generated from file proto/model/feature/hotel/cancellation_terms.proto (package carmen, syntax proto3)
/* eslint-disable */

import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import { file_proto_model_core_money } from "../../core/money_pb";

/**
 * Describes the file proto/model/feature/hotel/cancellation_terms.proto.
 */
export const file_proto_model_feature_hotel_cancellation_terms = /*@__PURE__*/
  fileDesc("CjJwcm90by9tb2RlbC9mZWF0dXJlL2hvdGVsL2NhbmNlbGxhdGlvbl90ZXJtcy5wcm90bxIGY2FybWVuIp0CChFDYW5jZWxsYXRpb25UZXJtcxI7ChdmcmVlX2NhbmNlbGxhdGlvbl91bnRpbBgBIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXASGgoScG9saWN5X2Rlc2NyaXB0aW9uGAIgASgJEkAKCXBlbmFsdGllcxgDIAMoCzItLmNhcm1lbi5DYW5jZWxsYXRpb25UZXJtcy5DYW5jZWxsYXRpb25QZW5hbHR5Gm0KE0NhbmNlbGxhdGlvblBlbmFsdHkSEwoLZGF5c19iZWZvcmUYASABKAUSGgoScGVuYWx0eV9wZXJjZW50YWdlGAIgASgBEiUKDnBlbmFsdHlfYW1vdW50GAMgASgLMg0uY2FybWVuLk1vbmV5QjZaNGdpdGh1Yi5jb20veXVuYWNhYmEvY2FybWVuL3Byb3RvL21vZGVsL2ZlYXR1cmUvaG90ZWxiBnByb3RvMw", [file_google_protobuf_timestamp, file_proto_model_core_money]);

/**
 * Describes the message carmen.CancellationTerms.
 * Use `create(CancellationTermsSchema)` to create a new message.
 */
export const CancellationTermsSchema = /*@__PURE__*/
  messageDesc(file_proto_model_feature_hotel_cancellation_terms, 0);

/**
 * Describes the message carmen.CancellationTerms.CancellationPenalty.
 * Use `create(CancellationTerms_CancellationPenaltySchema)` to create a new message.
 */
export const CancellationTerms_CancellationPenaltySchema = /*@__PURE__*/
  messageDesc(file_proto_model_feature_hotel_cancellation_terms, 0, 0);

